import './additionals.scss';

import { Field, useField, useFormikContext } from 'formik';
import { memo } from 'react';

import OptionPrice from '@/resources/components/product/options/OptionPrice';
import { useOptionContext } from '@/resources/hooks/useOptionsContext';

import { ICartItemValues } from '../../../../../store/ducks/order/types';

function Radio() {
  const { answer, optionIndex, selectOptionIndex, action } = useOptionContext();
  const { values, touched, setFieldTouched } = useFormikContext<ICartItemValues>();
  const selectOptionInForm = values.options[optionIndex]?.select_options[selectOptionIndex];
  const quantity = selectOptionInForm ? +selectOptionInForm.quantity : 0;

  const [field, { value }, { setValue }] = useField({
    type: 'radio',
    value: answer.id.toString(),
    name: `options.${optionIndex}.select_options.id`,
  });

  const onChange = () => {
    setValue(answer.id.toString());
    setFieldTouched(`options.${optionIndex}.select_options.${selectOptionIndex}.id`, true);

    values.options[optionIndex]?.select_options.forEach((selectOption) => {
      // eslint-disable-next-line no-param-reassign
      selectOption.chosen = false;

      // eslint-disable-next-line no-param-reassign
      if (selectOption.id === answer.id) selectOption.chosen = true;
    });
  };

  const isChecked = () => {
    const isTouched = !!(
      touched.options &&
      touched.options.length > 0 &&
      touched.options[optionIndex]?.select_options?.length
    );

    if (action === 'receive') return selectOptionInForm?.chosen;

    if (isTouched === false) return answer.marked_as_default;
    return answer.id.toString() === value;
  };

  return (
    <div className="d-flex align-items-center justify-content-between my-2">
      <div className="d-flex align-items-center flex-row">
        <Field
          type="hidden"
          name={`options.${optionIndex}.select_options.${selectOptionIndex}.id`}
          value={answer.id.toString()}
        />

        <label
          className="mb-0 cursor-pointer user-select-none"
          htmlFor={`radio-${optionIndex}-${selectOptionIndex}`}
          onClick={onChange}
        >
          <Field
            {...field}
            type="radio"
            onChange={onChange}
            checked={isChecked()}
            id={`radio-${optionIndex}-${selectOptionIndex}`}
          />

          <span className="ml-1 answer-title">{answer.title}</span>
        </label>
      </div>

      <div>
        <OptionPrice quantity={quantity} showSubtotal={false} />
      </div>
    </div>
  );
}

export default memo(Radio);
